import { AxiosResponse } from 'axios';
import { RequestParams } from '@/services/swagger/http-client';

const ServerSideFetch = async <R, P = RequestParams>(
  fetchMethod: (params?: P, fetchParams?: RequestParams) => Promise<AxiosResponse<R>>,
  params?: P,
  fetchParams?: RequestParams
): Promise<R> => {
  try {
    const res = params ? await fetchMethod(params, fetchParams) : await fetchMethod();
    return res.data;
    // return res?.data?.code === 200 ? res?.data?.data : null;
  } catch (error) {
    console.log(error);
    return {} as R;
  }
};
export default ServerSideFetch;
